import React, { memo, useRef } from 'react'
import { bool, func, string, oneOf, oneOfType, node } from 'prop-types'
import useClickAway from 'shared/util/custom-hooks/use-click-away'
import classNames from '../../helpers/class-names'
import TooltipContent from './tooltip-content'

import './_style.scss'

const blk = 'tooltip-wrapper'

const Tooltip = ({
  dataAutoId,
  category,
  size,
  title,
  message,
  position,
  align,
  isAdvanced,
  textNoWrap,
  children,
  className,
  isError,
  onHover,
  show,
  closeHandler,
}) => {
  const tooltipRef = useRef(null)
  useClickAway(tooltipRef, closeHandler)
  return (
    <div
      className={classNames({ blk, mods: [onHover && 'on-hover'] })}
      aria-label='information-tooltip'
      role='presentation'
      ref={tooltipRef}
    >
      {show && (
      <TooltipContent
        dataAutoId={dataAutoId}
        category={category}
        size={size}
        title={title}
        message={message}
        position={position}
        align={align}
        isAdvanced={isAdvanced}
        className={className}
        isError={isError}
        closeHandler={closeHandler}
        textNoWrap={textNoWrap}

      />
    )}
      {children}
    </div>
  )
}

Tooltip.propTypes = {
  dataAutoId: string,
  category: oneOf(['primary', 'secondary']),
  size: oneOf(['regular', 'small']),
  title: string,
  message: oneOfType([string, node]),
  position: oneOf(['top', 'bottom']),
  align: oneOf(['left', 'center', 'right']),
  isAdvanced: bool,
  isError: bool,
  show: bool,
  textNoWrap: bool,
  onHover: bool,
  children: node,
  className: string,
  closeHandler: func,
}

Tooltip.defaultProps = {
  dataAutoId: '',
  category: 'primary',
  size: 'regular',
  title: '',
  message: '',
  position: 'top',
  align: 'center',
  isAdvanced: false,
  isError: false,
  show: false,
  textNoWrap: false,
  onHover: false,
  children: null,
  className: '',
  closeHandler: () => {},
}

export default memo(Tooltip)



// WEBPACK FOOTER //
// ./common/components/tooltip/index.js